/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    year: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Year',
        defaultMessage: 'Year'
    },
    length: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Length (ft)',
        defaultMessage: 'Length (ft)'
    },
    brandManufacturer: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Brand/Manufacturer',
        defaultMessage: '* Brand/Manufacturer'
    },
    manufacturerCodeSearch: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Manufacturer Code Search',
        defaultMessage: 'Manufacturer Code Search'
    },
    manufacturer: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Manufacturer',
        defaultMessage: 'Manufacturer'
    },
    search: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Search',
        defaultMessage: 'Search'
    },
    reset: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Reset',
        defaultMessage: 'Reset'
    },
    cancel: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Cancel',
        defaultMessage: 'Cancel'
    },
    searchResults: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Search Results',
        defaultMessage: 'Search Results'
    },
    select: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Select',
        defaultMessage: 'Select'
    },
    brandOther: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Brand/Manufacturer - If other, please describe',
        defaultMessage: 'Brand/Manufacturer - If other, please describe'
    },
    model: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Model',
        defaultMessage: 'Model'
    },
    pontoontritoon: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Pontoon / tritoon',
        defaultMessage: 'Pontoon / tritoon'
    },
    maxSpeed: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Max Speed (mph)',
        defaultMessage: 'Max Speed (mph)'
    }, 
    horsepower: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Horsepower',
        defaultMessage: 'Horsepower'
    },
    hullMaterial: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Hull Material',
        defaultMessage: 'Hull Material'
    },
    ifotherexplain: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.If other, explain',
        defaultMessage: 'If other, explain'
    },
    serialNumber: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Serial Number',
        defaultMessage: 'Serial Number'
    },
    propulsionType: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Propulsion Type',
        defaultMessage: 'Propulsion Type'
    }, 
    doesVessel: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Does Vessel have All 3 of the following built in. Galley(Kitchen), Head(Bathroom) and Sleeping Quarters?',
        defaultMessage: 'Does Vessel have All 3 of the following built in. Galley(Kitchen), Head(Bathroom) and Sleeping Quarters?'
    },
    anymodifications: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Are there any modifications, power or otherwise?',
        defaultMessage: 'Are there any modifications, power or otherwise?'
    },
    mainEngine: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Main Engine',
        defaultMessage: 'Main Engine'
    },
    mainEngText: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.mainEngText',
        defaultMessage: 'Note: Electric motors not accepted as main motor, only auxiliary'
    },
    boatValue: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Boat Value',
        defaultMessage: 'Boat Value'
    },
    purchaseDate: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Purchase Date',
        defaultMessage: 'Purchase Date'
    },
    purchasePrice: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Purchase Price of All items ($ Canadian currency inclusive of tax)',
        defaultMessage: 'Purchase Price of All items ($ Canadian currency inclusive of tax)'
    },
    currentMarketTotal: {
        id: 'quoteandbind.RecMarLinedirectives.templates.BoatInformation.Current Market Total of all items ($)',
        defaultMessage: 'Current Market Total of all items ($)'
    }


});